import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';
import { useSession } from '../lib/auth';

export function RequireAuth() {
  const session = useSession();
  const location = useLocation();

  if (session.isPending) {
    return (
      <Box minH="100vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    );
  }
  if (!session.data) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
